import { AppPreviewActions } from '.'

export interface UpdateTiktokRepostStep1DataPayload {
    taskTitle?: string
    stepTitle?: string
    title?: string
    description?: string
    urlBlockTitle?: string
    mediaBlockTitle?: string
    mediaBlockMaxPhotos?: number
}

export const updateTiktokRepostStep1Data = (payload: UpdateTiktokRepostStep1DataPayload) => ({
    payload,
    type: AppPreviewActions.UPDATE_TIKTOK_REPOST_STEP1_DATA,
})
